module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickAway),
      expression: "onClickAway"
    }],
    staticClass: "do-dropdown",
    class: {
      'do-dropdown--open': _vm.isOpen
    }
  }, [_c('button', {
    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit",
    on: {
      "click": _vm.toggleOpen
    }
  }, [_vm._v("\n    Tilføj skabelon "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "do-dropdown"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "do-dropdown__dropdown"
  }, [_c('ul', [_vm._l((_vm.employmentTypes), function(employmentType) {
    return _c('li', {
      key: employmentType.id,
      staticClass: "do-dropdown__dropdown__item",
      on: {
        "click": function($event) {
          return _vm.selectEmploymentType(employmentType)
        }
      }
    }, [_c('div', {
      staticClass: "do-dropdown__dropdown__item__name"
    }, [(employmentType.manual_salary) ? _c('span', {
      staticClass: "icon-users"
    }) : _c('span', {
      staticClass: "icon-user"
    }), _vm._v("\n            " + _vm._s(employmentType.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "icon__bg-circle",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openEdit(employmentType)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    })])])
  }), _vm._v(" "), _c('li', {
    staticClass: "do-dropdown__dropdown__item do-dropdown__dropdown__item--add",
    on: {
      "click": function($event) {
        return _vm.setTemplateModalOpen(true)
      }
    }
  }, [_c('div', {
    staticClass: "btn-trans"
  }, [_vm._v("\n            " + _vm._s(_vm.createNewTitleText) + "\n          ")])])], 2)]) : _vm._e()]), _vm._v(" "), (_vm.isTemplateModalOpen) ? _c('DoEmploymentTemplate', {
    attrs: {
      "theEditEmploymentTemplate": _vm.editTemplate
    },
    on: {
      "created": function($event) {
        return _vm.$emit('onTemplateCreated')
      },
      "updated": function($event) {
        return _vm.$emit('onTemplateUpdated')
      },
      "deleted": function($event) {
        return _vm.$emit('onTemplateDeleted')
      },
      "close": _vm.closeTemplateModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49da139c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/DoEmploymentDropdown.vue
// module id = 1625
// module chunks = 1